export default __webpack_public_path__ + "static/media/iconPasta.4d8a08b6.svg";